export default __webpack_public_path__ + "static/media/homeSlideLeftImg.3e5abb80.png";